import { createBrowserRouter } from 'react-router';
import { AppShell } from './app-shell.tsx';
import { AuthLayout, HomeGate, RequireAuth } from './auth-guards.tsx';
import { NotFoundPage } from './not-found-page.tsx';

// Chaque page est chargée à la demande : la page de présentation n'embarque pas le code des outils.
export const router = createBrowserRouter([
  // Visiteur : page de présentation ; connecté : espace de création.
  { path: '/', element: <HomeGate /> },
  {
    element: <AuthLayout />,
    children: [
      {
        path: '/connexion',
        lazy: async () => ({ Component: (await import('../features/auth/sign-in-page.tsx')).SignInPage }),
      },
      {
        path: '/inscription',
        lazy: async () => ({ Component: (await import('../features/auth/sign-up-page.tsx')).SignUpPage }),
      },
      {
        path: '/mot-de-passe-oublie',
        lazy: async () => ({
          Component: (await import('../features/auth/forgot-password-page.tsx')).ForgotPasswordPage,
        }),
      },
      {
        path: '/reinitialiser-mot-de-passe',
        lazy: async () => ({
          Component: (await import('../features/auth/reset-password-page.tsx')).ResetPasswordPage,
        }),
      },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          {
            path: '/outils/:toolId',
            lazy: async () => ({ Component: (await import('../features/tools/tool-page.tsx')).ToolPage }),
          },
          {
            path: '/projets',
            lazy: async () => ({
              Component: (await import('../features/projects/projects-page.tsx')).ProjectsPage,
            }),
          },
          {
            path: '/projets/:projectId',
            lazy: async () => ({
              Component: (await import('../features/projects/project-page.tsx')).ProjectPage,
            }),
          },
          {
            path: '/bibliotheque',
            lazy: async () => ({
              Component: (await import('../features/library/library-page.tsx')).LibraryPage,
            }),
          },
          {
            path: '/reglages',
            lazy: async () => ({
              Component: (await import('../features/settings/settings-page.tsx')).SettingsPage,
            }),
          },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
